export class FacilityNoteAddModel {
    note: string;
    facilityId: number;
}